import { render, staticRenderFns } from "./BasicSerConsumption.vue?vue&type=template&id=4a949954&scoped=true&"
import script from "./BasicSerConsumption.vue?vue&type=script&lang=js&"
export * from "./BasicSerConsumption.vue?vue&type=script&lang=js&"
import style0 from "./BasicSerConsumption.vue?vue&type=style&index=0&id=4a949954&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a949954",
  null
  
)

export default component.exports